import ApplianceRepair from '../assets/icons/categories/markers/ApplianceRepairIcon.png';
import AudioMusicProduction from '../assets/icons/categories/markers/AudioMusicProduction.png';
import AutomotiveServices from '../assets/icons/categories/markers/AutomotiveServices.png';
import BeautyWellness from '../assets/icons/categories/markers/BeautyWellness.png';
import BusinessSupportConsulting from '../assets/icons/categories/markers/BusinessSupportConsulting.png';
import CleaningServices from '../assets/icons/categories/markers/CleaningServicesIcon.png';
import ContentTranslation from '../assets/icons/categories/markers/ContentTranslation.png';
import DesignArchitecture from '../assets/icons/categories/markers/DesignArchitecture.png';
import DesignCreative from '../assets/icons/categories/markers/DesignCreative.png';
import DigitalMarketing from '../assets/icons/categories/markers/DigitalMarketing.png';
import DoorWindowInstallation from '../assets/icons/categories/markers/DoorWindowInstallation.png';
import EducationTutoring from '../assets/icons/categories/markers/EducationTutoring.png';
import ElectricalServices from '../assets/icons/categories/markers/ElectricalServicesIcon.png';
import EventPlanning from '../assets/icons/categories/markers/EventPlanning.png';
import FinanceAccounting from '../assets/icons/categories/markers/FinanceAccounting.png';
import FitnessHealth from '../assets/icons/categories/markers/FitnessHealth.png';
import FurnitureServices from '../assets/icons/categories/markers/FurnitureServicesIcon.png';
import Gardening from '../assets/icons/categories/markers/GardeningIcon.png';
import GeneralConstruction from '../assets/icons/categories/markers/GeneralConstruction.png';
import HandymanServices from '../assets/icons/categories/markers/HandymanServicesIcon.png';
import InteriorFinishing from '../assets/icons/categories/markers/InteriorFinishing.png';
import ItDevelopment from '../assets/icons/categories/markers/ItDevelopment.png';
import LegalServices from '../assets/icons/categories/markers/LegalServices.png';
import PetServices from '../assets/icons/categories/markers/PetServices.png';
import PhotographyVideography from '../assets/icons/categories/markers/PhotographyVideography.png';
import PlumbingServices from '../assets/icons/categories/markers/PlumbingServicesIcon.png';
import PropertyCourier from '../assets/icons/categories/markers/PropertyCourier.png';
import RoofingFacade from '../assets/icons/categories/markers/RoofingFacade.png';
import { ReactComponent as ApplianceRepairIcon } from '../assets/icons/categories/ApplianceRepairIcon.svg';
import { ReactComponent as AudioMusicProductionIcon } from '../assets/icons/categories/AudioMusicProduction.svg';
import { ReactComponent as AutomotiveServicesIcon } from '../assets/icons/categories/AutomotiveServices.svg';
import { ReactComponent as BeautyWellnessIcon } from '../assets/icons/categories/BeautyWellness.svg';
import { ReactComponent as BusinessSupportConsultingIcon } from '../assets/icons/categories/BusinessSupportConsulting.svg';
import { ReactComponent as CleaningServicesIcon } from '../assets/icons/categories/CleaningServicesIcon.svg';
import { ReactComponent as ContentTranslationIcon } from '../assets/icons/categories/ContentTranslation.svg';
import { ReactComponent as DesignArchitectureIcon } from '../assets/icons/categories/DesignArchitecture.svg';
import { ReactComponent as DesignCreativeIcon } from '../assets/icons/categories/DesignCreative.svg';
import { ReactComponent as DigitalMarketingIcon } from '../assets/icons/categories/DigitalMarketing.svg';
import { ReactComponent as DoorWindowInstallationIcon } from '../assets/icons/categories/DoorWindowInstallation.svg';
import { ReactComponent as EducationTutoringIcon } from '../assets/icons/categories/EducationTutoring.svg';
import { ReactComponent as ElectricalServicesIcon } from '../assets/icons/categories/ElectricalServicesIcon.svg';
import { ReactComponent as EventPlanningIcon } from '../assets/icons/categories/EventPlanning.svg';
import { ReactComponent as FinanceAccountingIcon } from '../assets/icons/categories/FinanceAccounting.svg';
import { ReactComponent as FitnessHealthIcon } from '../assets/icons/categories/FitnessHealth.svg';
import { ReactComponent as FurnitureServicesIcon } from '../assets/icons/categories/FurnitureServicesIcon.svg';
import { ReactComponent as GardeningIcon } from '../assets/icons/categories/GardeningIcon.svg';
import { ReactComponent as GeneralConstructionIcon } from '../assets/icons/categories/GeneralConstruction.svg';
import { ReactComponent as HandymanServicesIcon } from '../assets/icons/categories/HandymanServicesIcon.svg';
import { ReactComponent as InteriorFinishingIcon } from '../assets/icons/categories/InteriorFinishing.svg';
import { ReactComponent as ItDevelopmentIcon } from '../assets/icons/categories/ItDevelopment.svg';
import { ReactComponent as LegalServicesIcon } from '../assets/icons/categories/LegalServices.svg';
import { ReactComponent as PetServicesIcon } from '../assets/icons/categories/PetServices.svg';
import { ReactComponent as PhotographyVideographyIcon } from '../assets/icons/categories/PhotographyVideography.svg';
import { ReactComponent as PlumbingServicesIcon } from '../assets/icons/categories/PlumbingServicesIcon.svg';
import { ReactComponent as PropertyCourierIcon } from '../assets/icons/categories/PropertyCourier.svg';
import { ReactComponent as RoofingFacadeIcon } from '../assets/icons/categories/RoofingFacade.svg';

import type { FC, SVGProps } from 'react';

type SvgComp = FC<SVGProps<SVGSVGElement>>;

const ICON_URLS: Array<[RegExp, string]> = [
  [/appliance|repair/i, ApplianceRepair],
  [/audio|music|production/i, AudioMusicProduction],
  [/automotive/i, AutomotiveServices],
  [/beauty|wellness/i, BeautyWellness],
  [/business|support|consulting/i, BusinessSupportConsulting],
  [/cleaning/i, CleaningServices],
  [/content|translation/i, ContentTranslation],
  [/design|architecture/i, DesignArchitecture],
  [/design|creative/i, DesignCreative],
  [/digital|marketing/i, DigitalMarketing],
  [/door|window|installation/i, DoorWindowInstallation],
  [/education|tutoring/i, EducationTutoring],
  [/electrical|electric/i, ElectricalServices],
  [/event|planning/i, EventPlanning],
  [/finance|accounting/i, FinanceAccounting],
  [/fitness|health/i, FitnessHealth],
  [/furniture/i, FurnitureServices],
  [/gardening|landscaping/i, Gardening],
  [/general|construction/i, GeneralConstruction],
  [/handyman/i, HandymanServices],
  [/interior|finishing/i, InteriorFinishing],
  [/\bit\b|development/i, ItDevelopment],
  [/legal/i, LegalServices],
  [/pet/i, PetServices],
  [/photography|videography/i, PhotographyVideography],
  [/plumbing|heating|freezer|fridge/i, PlumbingServices],
  [/property|courier/i, PropertyCourier],
  [/roofing|facade/i, RoofingFacade],
];

const ICON_COMPONENTS: Array<[RegExp, SvgComp]> = [
  [/appliance|repair/i, ApplianceRepairIcon],
  [/audio|music|production/i, AudioMusicProductionIcon],
  [/automotive/i, AutomotiveServicesIcon],
  [/beauty|wellness/i, BeautyWellnessIcon],
  [/business|support|consulting/i, BusinessSupportConsultingIcon],
  [/cleaning/i, CleaningServicesIcon],
  [/content|translation/i, ContentTranslationIcon],
  [/architecture/i, DesignArchitectureIcon],
  [/creative/i, DesignCreativeIcon],
  [/digital|marketing/i, DigitalMarketingIcon],
  [/door|window|installation/i, DoorWindowInstallationIcon],
  [/education|tutoring/i, EducationTutoringIcon],
  [/electrical|electric/i, ElectricalServicesIcon],
  [/event|planning/i, EventPlanningIcon],
  [/finance|accounting/i, FinanceAccountingIcon],
  [/fitness|health/i, FitnessHealthIcon],
  [/furniture/i, FurnitureServicesIcon],
  [/gardening|landscaping/i, GardeningIcon],
  [/general|construction/i, GeneralConstructionIcon],
  [/handyman/i, HandymanServicesIcon],
  [/interior|finishing/i, InteriorFinishingIcon],
  [/\bit\b|development/i, ItDevelopmentIcon],
  [/legal/i, LegalServicesIcon],
  [/pet/i, PetServicesIcon],
  [/photography|videography/i, PhotographyVideographyIcon],
  [/plumbing|heating|freezer|fridge/i, PlumbingServicesIcon],
  [/property|courier/i, PropertyCourierIcon],
  [/roofing|facade/i, RoofingFacadeIcon],
];

const pickFrom = <T>(
  pairs: Array<[RegExp, T]>,
  specialty: string,
  fallback: T,
) => {
  const s = specialty.toLowerCase();
  for (const [re, val] of pairs) if (re.test(s)) return val;
  return fallback;
};

export const getCategoryIconUrl = (specialty: string): string =>
  pickFrom(ICON_URLS, specialty, PlumbingServices);

export const getCategoryIconComponent = (specialty: string): SvgComp =>
  pickFrom(ICON_COMPONENTS, specialty, PlumbingServicesIcon);
